import React, { useState, useEffect } from "react";
import {
  PositionLogoContainer,
  SizeLogoContainer,
  Title,
  RadioSize,
  Body,
} from "./LogosStyles.styled";
import UploadImage from "../UploadImage/UploadImage";
import PubSub from "pubsub-js";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";

const LogosStyles = ({ styleLogoAll }) => {
  const [styleLogo, setStyleLogo] = useState({
    image: {},
    nameImage: "",
    sizeImage: { width: "18%" },
    position: "",
  });

  useEffect(() => {
    if (styleLogoAll) {
      setStyleLogo(styleLogoAll);
    }
  }, [styleLogoAll]);

  let handleStyleLogo = (type, item, urlPreviewImage) => {
    let updateStyleLogo = Object.assign({}, styleLogo);
    switch (type) {
      case "size":
        updateStyleLogo.sizeImage = item;
        break;
      case "position":
        updateStyleLogo.position = item;
        break;
      case "imagenFile":
        updateStyleLogo.image = item;
        updateStyleLogo.nameImage = item ? item[0].name : "";
        if (urlPreviewImage) {
          PubSub.publish("urlPreviewImageLogo", urlPreviewImage);
        }
        break;
      default:
        break;
    }

    setStateSurveyConfiguration(updateStyleLogo, "Logo");
  };

  let handleOnChangeSize = (event) => {
    handleStyleLogo("size", { width: event.target.value }, "");
  };

  let handleOnChangePosition = (event) => {
    handleStyleLogo("position", event.target.value, "");
  };

  return (
    <div>
      <PositionLogoContainer>
        <UploadImage
          displayNameButton="+ Logo"
          setFile={handleStyleLogo}
          nameFile={styleLogo.nameImage}
        ></UploadImage>
      </PositionLogoContainer>
      <SizeLogoContainer>
        <Title>Size</Title>
        <Body>
          <RadioSize>
            <input
              type="radio"
              name="sizeImage"
              value="25%"
              onChange={handleOnChangeSize}
              checked={styleLogo.sizeImage.width === "25%"}
            />
            <label>Big</label>
          </RadioSize>
          <RadioSize>
            <input
              type="radio"
              name="sizeImage"
              value="20%"
              onChange={handleOnChangeSize}
              checked={styleLogo.sizeImage.width === "20%"}
            />
            <label>Medium</label>
          </RadioSize>
          <RadioSize>
            <input
              type="radio"
              name="sizeImage"
              value="15%"
              onChange={handleOnChangeSize}
              checked={styleLogo.sizeImage.width === "15%"}
            />
            <label>Small</label>
          </RadioSize>
        </Body>
      </SizeLogoContainer>

      <PositionLogoContainer>
        <Title>Position</Title>
        <Body>
          <RadioSize>
            <input
              type="radio"
              name="positionImage"
              value="flex-end"
              onChange={handleOnChangePosition}
              checked={styleLogo.position === "flex-end"}
            />
            <label>Right</label>
          </RadioSize>
          <RadioSize>
            <input
              type="radio"
              name="positionImage"
              value="center"
              onChange={handleOnChangePosition}
              checked={styleLogo.position === "center"}
            />
            <label>Center</label>
          </RadioSize>
          <RadioSize>
            <input
              type="radio"
              name="positionImage"
              value="flex-start"
              onChange={handleOnChangePosition}
              checked={styleLogo.position === "flex-start"}
            />
            <label>Left</label>
          </RadioSize>
        </Body>
      </PositionLogoContainer>
    </div>
  );
};

export default LogosStyles;
